module.exports = __webpack_public_path__ + "assets/img/model-2.b0b205af.png";